import { styled } from "@mui/material/styles";

const AuthWrapper1 = styled("div")(({ theme }: any) => ({
	backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : theme.palette.grey[100],
	minHeight      : "100%"
}));

export default AuthWrapper1;
